import { useEffect, useState } from "react";
import { FirestoreService } from "../../../../../api/firebase/firestoreService";
import { FirestoreDocumentReference } from "../../../../../api/firebase/references";
import type { FirstStpReviewRuleDoc } from "./firstStpReviewRuleUtils";

/** Loads the first STP review rules document from Firestore once on mount. */
export function useFirstStpConfig() {
  const [data, setData] = useState<FirstStpReviewRuleDoc | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    let cancelled = false;

    const fetchConfig = async () => {
      setLoading(true);
      setError(null);
      try {
        const result = await FirestoreService.getDocument<FirstStpReviewRuleDoc>(
          FirestoreDocumentReference.pharmacyOrderUpdatesFirstStpReview(),
        );
        if (!cancelled) {
          setData(result);
        }
      } catch (err) {
        const message = err instanceof Error ? err.message : String(err);
        if (message.includes("does not exist")) {
          if (!cancelled) {
            setData(null);
          }
        } else {
          const errorInstance =
            err instanceof Error ? err : new Error(String(err));
          if (!cancelled) {
            setError(errorInstance);
          }
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    fetchConfig();
    return () => {
      cancelled = true;
    };
  }, []);

  return { data, loading, error };
}
